import React, { useEffect, useRef, useState } from 'react';
// Redux
import { useSelector } from 'react-redux';
// Components
import CardVideo from '../../Components/CardVideo';
import InternalContainer from '../../Components/InternalContainer';
import Pagination from '../../Components/Pagination';
import ThumbnailEn from '../../Images/thumbnail-eng.jpg';
import ThumbnailEs from '../../Images/thumbnail-es.jpg';

// Nouvelle Images
import NouvelleInsteresting from '../../Images/Tutorials/nouvelle-insteresting.png';

// Hooks
import { useScrollToTop } from '../../hooks/useScrollToTop';
// Services
import {
  getVideosTutorials,
  getVideosTutorialsNouvelle,
} from '../../services/getVideosTutorials';
// Syles
import './TutorialsPage.css';
import { FavoriteCategory } from '../FavoriteDetail/types';
import { useAuth } from '../../hooks/useAuth';
import { isCosmetology } from '../../utils/isCosmetology';
import { useLocation, useNavigate } from 'react-router-dom';
import { generateCertificatePDF } from '../../Components/TutorialCertificate';

import CardInterestingLinksHome from '../../Components/CardInterestingLinksHome';
// Translate
import { useTranslation } from 'react-i18next';

const TutorialsPage = () => {
  const { t } = useTranslation();
  const { isAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasDownloadedRef = useRef(false);
  // Hookks
  const { handleScrollToTop } = useScrollToTop();

  // Slices
  const { institutionCode, languageInstitution } = useSelector(
    (state) => state.institution
  );
  const { user_name, user_lastname } = useSelector((state) => state.user);

  // Variables
  const [pageShowedTutorials, setPageShowedTutorials] = useState(1);

  const dataVideos = getVideosTutorials(institutionCode);
  const nouvelleVideos = getVideosTutorialsNouvelle();

  // Pagination
  const itemsPerPage = 12;
  const totalNews = dataVideos.length;
  const indexOfLastItem = pageShowedTutorials * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = dataVideos.slice(indexOfFirstItem, indexOfLastItem);
  const currentNouvelleItems = nouvelleVideos.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(totalNews / itemsPerPage);

  // Funcion de cambio de paginacion
  const handlePageChange = (newPage) => {
    handleScrollToTop(0);
    if (newPage > pageShowedTutorials) {
      if (
        pageShowedTutorials < totalPages ||
        (Math.ceil(getVideosTutorials()?.length / itemsPerPage) > 1 &&
          totalPages === 0)
      ) {
        setPageShowedTutorials(newPage);
      }
    } else {
      if (pageShowedTutorials > 1) {
        setPageShowedTutorials(newPage);
      }
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has('download_certificate') && !hasDownloadedRef.current) {
      hasDownloadedRef.current = true;
      generateCertificatePDF(
        `${user_name} ${user_lastname}`,
        new Date(),
        institutionCode
      );
      params.delete('download_certificate');
      const newSearch = params.toString();

      navigate(
        {
          pathname: location.pathname,
          search: newSearch ? `?${newSearch}` : '',
        },
        { replace: true }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, location.pathname, navigate]);

  return (
    <main className='Tutorials'>
      <InternalContainer className='no-filters'>
        {!isCosmetology(institutionCode) && (
          <>
            <div className='banner-tutorial-section'>
              <div className='content-banner-tutorial'>
                <div className='title-banner-tutorial'>
                  <b>{t('Getting Started')}</b>{' '}
                  {t('with Aquinas Online Library')}
                </div>
                <p className='description-banner-tutorial'>
                  {t('Learn to use OLIB with these two interactive videos')}
                </p>
                <p className='helper-banner-tutorial'>
                  {t('Make the most of OLIB and enhance your learning experience')}
                </p>
              </div>
              <div className='videos-banner-tutorial'>
                {languageInstitution === 'en' ? (
                  <CardVideo
                    image={ThumbnailEn}
                    time={'6:00'}
                    title={'How can I make the most of Aquinas Online Library?'}
                    description={`We understand that getting familiar with a new platform can take time. That's why we've created a detailed interactive video to guide you through all the features Aquinas Online Library has to offer.`}
                    url={
                      'https://interactivevideo.aquinas.tech/wp-admin/admin-ajax.php?action=h5p_embed&id=6'
                    }
                    language={'en'}
                    type={'external'}
                    showFavoriteButton={false}
                    isTutorial={true}
                    userFullName={`${user_name} ${user_lastname}`}
                  />
                ) : (
                  <CardVideo
                    image={ThumbnailEs}
                    time={'6:00'}
                    title={
                      '¿Cómo puedo aprovechar al máximo Aquinas Online Library?'
                    }
                    description={`Entendemos que familiarizarse con una nueva plataforma puede llevar tiempo. Por eso, hemos creado un video interactivo detallado para guiarte a través de todas las funcionalidades que Aquinas Online Library tiene para ofrecerte.`}
                    url={
                      'https://interactivevideo.aquinas.tech/wp-admin/admin-ajax.php?action=h5p_embed&id=5'
                    }
                    language={'en'}
                    type={'external'}
                    showFavoriteButton={false}
                    isTutorial={true}
                    userFullName={`${user_name} ${user_lastname}`}
                  />
                )}
              </div>
            </div>
            <section className='AmericanLifeContainer'>
              {currentItems?.map((video, i) => {
                return (
                  <CardVideo
                    key={i}
                    image={video.image}
                    time={video.duration}
                    title={video.title}
                    description={video.description}
                    url={video.url}
                    language={video.language}
                    type={video.type}
                    favoriteCategory={FavoriteCategory.TUTORIALS}
                    showFavoriteButton={isAuth() ? true : false}
                  />
                );
              })}
            </section>
          </>
        )}
        {isCosmetology(institutionCode) && (
          <>
            {institutionCode === 'NOUVELLE' && (
              <>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <section
                    // className='AmericanLifeContainer'
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      maxWidth: '500px',
                    }}
                  >
                    {currentNouvelleItems?.map((video, i) => {
                      return (
                        <CardVideo
                          key={i}
                          image={video.image}
                          time={video.duration}
                          title={video.title}
                          description={video.description}
                          url={video.url}
                          language={video.language}
                          type={video.type}
                          favoriteCategory={FavoriteCategory.TUTORIALS}
                          showFavoriteButton={isAuth() ? true : false}
                        />
                      );
                    })}
                  </section>
                </div>

                <section class='interestingLinksResults'>
                  <CardInterestingLinksHome
                    title={'Catálogo en español Junio 2025'}
                    image_url={NouvelleInsteresting}
                    url={
                      'https://institutions-assets.s3.us-east-2.amazonaws.com/interesting-links/catalogo_junio_nouvelle_2025.pdf'
                    }
                    description={''}
                    type='resource'
                    resource_origin={'Multidisciplinary'}
                    favoriteCategory={FavoriteCategory.INTERESTING_LINKS}
                    showFavoriteButton={isAuth() ? true : false}
                  />
                  <CardInterestingLinksHome
                    title={'Catalogo en inglés mayo 2025'}
                    image_url={NouvelleInsteresting}
                    url={
                      'https://institutions-assets.s3.us-east-2.amazonaws.com/interesting-links/catalogo_mayo_nouvelle_2025.pdf'
                    }
                    description={''}
                    type='resource'
                    resource_origin={'Multidisciplinary'}
                    favoriteCategory={FavoriteCategory.INTERESTING_LINKS}
                    showFavoriteButton={isAuth() ? true : false}
                  />
                </section>
              </>
            )}
          </>
        )}
        <Pagination
          pageShowed={pageShowedTutorials}
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />
      </InternalContainer>
    </main>
  );
};

export default TutorialsPage;
